export const ADVENTURE_GREEN = '#59dd7d';
export const ADVENTURE_GREEN_FOCUSED = '#50c871';
export const ADVENTURE_GREEN_AUTOFILLED = '#E5F9EB';
export const ADVENTURE_GREEN_STRESSED = '#e6fded';
export const NIGHTINGALE_BLACK = '#3f4144';
export const SENSATION_WHITE = '#ffffff';
export const BACKGROUND_GRAY = '#f7f7f7';
export const LINE_GRAY = '#edeff0';
export const ELEMENT_GRAY = '#c8cccf';
export const INACTIVE_GRAY = '#92969c';
export const RIOJA_RED = '#D83D42';
export const RIOJA_RED_FOCUSED = '#A61D23';
export const SUNSHINE_YELLOW = '#EAC51B';
export const CHEERFUL_ORANGE = '#BD5A0E';
export const BLACK_BACKDROP = 'rgba(0, 0, 0, 0.3)';
export const WHITE_BACKDROP = 'rgba(255, 255, 255, 0.25)';
export const BLACK_LIGHT_OVERLAY = 'rgba(0, 0, 0, 0.4)';
export const GRAY_LIGHT_OVERLAY = 'rgba(63, 65, 68, 0.4)';
export const BLACK_OVERLAY_OPACITY_93 = 'rgba(0, 0, 0, 0.93)';
export const BLACK_OVERLAY = 'rgba(0, 0, 0, 0.7)';
export const GRAY_OVERLAY = 'rgba(63, 65, 68, 0.7)';
export const WHITE_OVERLAY = 'rgba(255, 255, 255, 0.6)';
const COLORS = {
  ADVENTURE_GREEN,
  ADVENTURE_GREEN_FOCUSED,
  ADVENTURE_GREEN_AUTOFILLED,
  ADVENTURE_GREEN_STRESSED,
  NIGHTINGALE_BLACK,
  SENSATION_WHITE,
  BACKGROUND_GRAY,
  LINE_GRAY,
  ELEMENT_GRAY,
  INACTIVE_GRAY,
  SUNSHINE_YELLOW,
  CHEERFUL_ORANGE,
  RIOJA_RED,
  RIOJA_RED_FOCUSED,
  BLACK_OVERLAY,
  GRAY_OVERLAY,
  WHITE_OVERLAY,
  BLACK_BACKDROP,
  WHITE_BACKDROP,
  BLACK_LIGHT_OVERLAY,
  GRAY_LIGHT_OVERLAY
};
export default COLORS;